import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ChevronDownSmall } from "@/icons";
import styles from "./PermissionSelect.module.scss";

export interface SelectOption<T = string> {
    value: T;
    label: string;
}

interface PermissionSelectProps<T> {
    options: SelectOption<T>[];
    selectedValue: SelectOption<T>;
    onChange: (option: SelectOption<T>) => void;
    disabled?: boolean;
}

export const PermissionSelect = <T,>({
    options,
    selectedValue,
    onChange,
    disabled = false,
}: PermissionSelectProps<T>) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({});

    const handleToggle = () => {
        if (!isOpen && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();

            setDropdownStyle({
                position: "fixed",
                top: rect.bottom + 4,
                left: rect.left,
                zIndex: 9999,
            });
        }

        setIsOpen((prev) => !prev);
    };

    const handleSelect = (option: SelectOption<T>) => {
        onChange(option);
        setIsOpen(false);
    };

    // закрытие при клике вне
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (!containerRef.current?.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <div className={styles.select} ref={containerRef}>
            <div className={styles.selectHeader} onClick={handleToggle}>
                {" "}
                <div className={styles.label}>{selectedValue.label}</div>
                <ChevronDownSmall />
            </div>

            {isOpen &&
                !disabled &&
                createPortal(
                    <div className={styles.dropdown} style={dropdownStyle}>
                        {options.map((option) => (
                            <div
                                key={String(option.value)}
                                className={styles.option}
                                onClick={() => handleSelect(option)}
                            >
                                <div className={styles.label}>{option.label}</div>
                            </div>
                        ))}
                    </div>,
                    document.body,
                )}
        </div>
    );
};
